<template>
  <div class="p-0 m-0">
    <p
      v-for="(item, key) in question.alternatives"
      :key="key"
      v-show="item.answer"
      class="m-0 worksansr"
    >
      {{ item.label }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    category_id: [String, Number],
    question: Object,
  },
};
</script>
